/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Radius Proxy API
 * # OpenAPI Specification
This API is documented in [OpenAPI v3.1.0](https://swagger.io/specification/) format.

# Authentication
The API supports two authentication methods:

# Error Responses
Whenever an error appears (whether it's a notifier bug which leads to an internal server error,
or a simple validation error) the API response will be in the
[Problem Details](https://tools.ietf.org/html/rfc7807) format

For example, a 404 response body would look like:
```json
{
    "status": 404,
    "type": "problems/resource-not-found",
    "title": "Resource not found",
    "detail": "Some entity with ID 'sdsada' does not exist."
}
```

# Subscriber Operations

## New Subscriber
Creates authentication data and assigns a speed profile based on USOC-to-group-name mapping.

## Suspend Subscriber
Adds a disable entry for the user with possible values: `non-payment`, `abuse`.

## Remove Suspension
Removes the disable entry to restore service.

## Upgrade/Downgrade Subscriber
Updates the assigned speed profile.

## Manage Static IPs (Idempotent)
Add or remove IP addresses assigned to the subscriber.

## Cancel Subscriber
Complete subscriber cancellation that removes authentication data, speed profile association,
all static IPs, and disable entries.

 * OpenAPI spec version: 1.0
 */

/**
 * The reason for suspension. Required when `is_suspended` is `true`.
- `non-payment`: Subscriber suspended due to non-payment
- `abuse`: Subscriber suspended due to abuse

 */
export type UpsertSubscriberSuspensionStatusSuspendedReason =
  (typeof UpsertSubscriberSuspensionStatusSuspendedReason)[keyof typeof UpsertSubscriberSuspensionStatusSuspendedReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertSubscriberSuspensionStatusSuspendedReason = {
  'non-payment': 'non-payment',
  abuse: 'abuse',
} as const;
